import { z } from "zod";

/** Search params `/konfiguracja/pracownicy` — każde pole z `.catch`, zły link nie wywraca trasy. */
export const staffSearchSchema = z.object({
	/** idfirm wybranej apteki. */
	apteka: z.coerce.number().int().positive().optional().catch(undefined),
	/** Szukane nazwisko, imię albo login (lista pracowników). */
	q: z.string().optional().catch(undefined),
});

export type StaffSearch = z.infer<typeof staffSearchSchema>;
